export const DEVICE_COOKIE_NAME = '_device_id';
